import React, {useEffect, useState} from "react";
import {AppState} from "../RootReducer";
import {useSelector} from "react-redux";
import {usePrevious} from "../user/ui/utils";
import {LoginStatus} from "../http/Types";
export const CHAT_OPENED = "chat-opened"
export const CHAT_CLOSED = "chat-closed";
export const FreshChatWrapper = () => {
    const settings = useSelector((app : AppState) => app.settings);
    //wait to mount until settings are fetched;
    if(!settings.settings) {
        return <div/>;
    }

    return <FreshChatWidget />
}
export function openFreshChat() {
    if(window.fcWidget) {
        window.fcWidget.show();
        window.fcWidget.open();
    }
}
export function hideFreshChat() {
    if(window.fcWidget) {
        window.fcWidget.hide();
    }
}
export const FreshChatWidget = () => {
    const settings = useSelector((app : AppState) => app.settings?.settings);
    const mobile  = useSelector((app : AppState) => app.settings.mobile);

    const user = useSelector((app : AppState) => app.user);
    const [scriptLoaded, setScriptLoaded] = useState<boolean>(false);

    const hideOrShow = (mobileMode : boolean) => {

        if(window.fcWidget) {
            if(mobileMode) {
                window.fcWidget.hide();
            } else {
                window.fcWidget.show();
            }
        }
    }
    const  loadScript = () => {
        let id = 'freshchat-lib'
        if (!scriptLoaded && (document.getElementById(id) || window.fcWidget)) {
           setScriptLoaded(true);
        } else if(!scriptLoaded) {
            let script = document.createElement('script')
            script.async = true;
            script.type = 'text/javascript'
            script.src = 'https://wchat.freshchat.com/js/widget.js'
            script.id = id;
            script.addEventListener("load", ()=>{
               setScriptLoaded(true);
            })
            document.head.appendChild(script);
        }


    }
    const initWidget = () => {
        let token = settings?.freshChatWidgetToken;
        let siteId = settings?.freshChatWidgetSiteId;
        let host = "https://wchat.freshchat.com";

        if(settings?.freshChatHost && settings.freshChatHost.trim().length > 0) {
            host =  settings.freshChatHost;
        }
        if(token && user) {
            let config : any =  {...settings?.freshChatConfig || {}, headerProperty : { ...settings?.freshChatConfig?.headerProperty || {}, hideChatButton : true}};
            config = {...config, eagerLoad : false };
            window.fcWidget.init({
                token: token,
                host: host,
                siteId: siteId,
                config : config
            });
            window.fcWidget.on("widget:opened", (resp : any) => {
                window.postMessage(CHAT_OPENED);
            });
            window.fcWidget.on("widget:closed", (resp : any) => {
                window.postMessage(CHAT_CLOSED);
            });
        }
    }
    const prevStatus = usePrevious(user.status);
    useEffect(()=> {
        if(prevStatus !== LoginStatus.LOGGED_IN && user.status === LoginStatus.LOGGED_IN) {

            try {
                window.fcWidget && window.fcWidget.user.setProperties({
                    email: user.user?.email,
                    "User Id": user.user?.userUid
                });
            } catch (e) {
                console.log("Unable to set user in fresh chat",e);
            }
        }
    },[user.status])
    const prevLoaded = usePrevious(scriptLoaded);
    useEffect(()=>{
        if(settings?.freshChatEnabled && scriptLoaded === false) {
            loadScript();
        }
    },[settings?.freshChatEnabled, scriptLoaded])

    let prevScriptLoaded = usePrevious(scriptLoaded);
    useEffect(()=>{
        if(prevScriptLoaded == false && scriptLoaded == true) {
            initWidget();
        }
    },[scriptLoaded]);

    return <div></div>
}

export default FreshChatWrapper;